<nav aria-label="barre de navigation" class="navbar navbar-expand-md d-none d-md-block d-print-none" id="navbar"
     role="navigation">
  <ul class="navbar-nav">
    <ng-container *ngFor="let item of navItems">
      <li *ngIf="item.id ===0
    || item.id === 1 && (isListAvailable | async)
    || item.id === 2 && (isCreateAvailable | async)
    || item.id === 3 && displayPreference && (isPreferenceAvailable | async)
    || item.id === 4 && (displayProfil | async)
    || item.id === 5 && (isCreateAvailable | async)"
          [routerLinkActive]="['nav-active']" class="nav-item transition">
        <a [routerLink]="item.routerUrl" class="text-decoration-none" id="signer" title="{{ item.title }}">
          <span class="hover hover-transition">{{ item.menu_upper | translate }}</span>
        </a>
      </li>
    </ng-container>
    <li class="nav-item transition">
      <a class="text-decoration-none"
         href="https://portail.chorus-pro.gouv.fr/aife_documentation?id=kb_search&kb_knowledge_base=49831ce887fa8a50636765380cbb356a&spa=1&language=fr&kb_category=a94001f6c304669077c2530ed401310a"
        target="_blank"
        rel="noopener noreferrer"
        title="DOCUMENTATION"
        aria-label="accéder à la documentation du service avis de publicité | nouvel onglet (onglet externe)">
       <span class="hover hover-transition">DOCUMENTATION</span>
        <mat-icon class="doc-ext-icon" aria-hidden="true">launch</mat-icon>
      </a>
    </li>

  </ul>
</nav>
<nav role="navigation">
  <div class="mobile-nav d-block d-md-none d-print-none">
    <nav aria-label="barre de navigation" id="sidenav-mobile" role="navigation">
      <div class="header d-inline-block">
        <img alt="logo esginature" class="float-left" src="./assets/img/Logo-SignatureWeb.png">
        <button (click)="closeMenu()" class="mat-icon notranslate material-icons mat-icon-no-color"
                aria-label="Close Menu" aria-hidden="true">close
        </button>
      </div>
      <div role="navigation">
        <ul role="list">
          <li role="listitem">
            <span>{{ 'general.menu' | translate }}</span>
          </li>
          <li *ngFor="let item of navItems" [routerLinkActive]="['nav-active']" role="listitem">
            <a (click)="closeMenu(); redirect( item.id )" class="underline">{{ item.menu_lower | translate }}</a>
          </li>
        </ul>
      </div>

      <div>
        <ul *ngFor="let item of hamburgerItems" role="list">
          <li role="listitem">
            <span>{{ item.title | translate }}</span>
          </li>
          <li *ngFor="let link of item.links" role="listitem">
            <a href="{{ link.url | translate }}" hreflang="{{ this.mapLang.get(currentLanguage) }}"
               lang="{{ this.mapLang.get(currentLanguage) }}" rel="noopener noreferrer"
               role="link">{{ link.text | translate }}
              <mat-icon *ngIf="item.externalLink" aria-hidden="true" role="img">launch</mat-icon>
            </a>
          </li>
        </ul>
      </div>
      <div>
      </div>
    </nav>
  </div>
</nav>
